var _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIcDashboard = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F8D822",
    d: "M8.333 11.667H1.667a.834.834 0 0 1-.834-.834v-10c0-.46.374-.833.834-.833h6.666c.46 0 .834.373.834.833v10c0 .46-.374.834-.834.834z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#141103",
    d: "M8.333 20H1.667a.834.834 0 0 1-.834-.833v-5c0-.46.374-.834.834-.834h6.666c.46 0 .834.374.834.834v5c0 .46-.374.833-.834.833zM18.333 6.667h-6.666a.834.834 0 0 1-.834-.834v-5c0-.46.374-.833.834-.833h6.666c.46 0 .834.373.834.833v5c0 .46-.374.834-.834.834z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8D822",
    d: "M18.333 20h-6.666a.834.834 0 0 1-.834-.833v-10c0-.46.374-.834.834-.834h6.666c.46 0 .834.374.834.834v10c0 .46-.374.833-.834.833z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcDashboard, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-dashboard.7e4d6e12.svg";
export { ForwardRef as ReactComponent };